import { useEffect, useState } from 'react';

import { $searchFilters } from '@client/core/atoms/config.js';
import type { FilterUpdatePayloadType } from '@client/core/utils/refreshKeywords.js';
import { events, messageBus } from '@schibsted-nmp/advertising-events';

export function useForceRerenderOnFilteringOrPaginating(): string {
  // Changes render key whenever filtering or paginating event occurs.
  // Used to force re-render of Contentful, ensuring internal query in Contentful re-runs.

  const searchFiltersValue = JSON.stringify($searchFilters.value?.current);

  const [renderKey, setRenderKey] = useState(searchFiltersValue);

  const handleFilteringOrPaginating = (searchParamsKey: string) => {
    setRenderKey(searchParamsKey);
  };

  useEffect(() => {
    const unsubscribe = messageBus.subscribe(
      events.SEARCH.channel,
      events.SEARCH.FILTER.topic,
      (event) => {
        const payload = event.payload as FilterUpdatePayloadType;
        const searchParamsKey = JSON.stringify(payload.searchParams);
        handleFilteringOrPaginating(searchParamsKey);
      }
    );
    return () => {
      unsubscribe();
    };
  }, []);

  return renderKey;
}
